import styled from 'styled-components'

export const SettingValueText = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 22px;
  font-weight: 500;
  margin: 0;
`
